/**
 * Teto de linhas do export de relatórios. A regra é do backend
 * (bng-health/minhaescala-backend#3433, `REPORT_EXPORT_MAX_ROWS`): acima disso
 * ele responde 400. Aqui só antecipamos o aviso com o `totalItems` da listagem,
 * que usa o mesmo filtro e a mesma permissão do export. Se o total estiver
 * desatualizado, o export segue e o 400 do backend chega ao toast.
 */
export const REPORT_EXPORT_MAX_ROWS = 10000

export const formatRowCount = (count: number): string => count.toLocaleString('pt-BR')
